import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogOut, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function AdminLayout({ children, title, back }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-40 bg-brand-blue text-white">
        <div className="max-w-6xl mx-auto flex items-center justify-between px-4 h-16">
          <div className="flex items-center gap-3">
            {back && (
              <button
                data-testid="admin-back-btn"
                onClick={() => nav(back)}
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center"
              >
                <ArrowLeft className="w-5 h-5" />
              </button>
            )}
            <Link to="/admin" className="font-heading font-black text-lg" data-testid="admin-brand">
              Spaccatempo · Admin
            </Link>
          </div>
          <div className="flex items-center gap-2">
            <span className="hidden sm:inline text-xs opacity-80">{user?.email}</span>
            <Button
              variant="ghost"
              size="sm"
              onClick={logout}
              data-testid="admin-logout-btn"
              className="text-white hover:bg-white/10"
            >
              <LogOut className="w-4 h-4 mr-1" /> Esci
            </Button>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 py-6">
        {title && <h1 className="font-heading font-black text-2xl text-brand-blue mb-4">{title}</h1>}
        {children}
      </main>
    </div>
  );
}
